/**
 * 防腐层统一导出
 * 所有API调用都通过适配器，隔离后端变化
 */

export * from './types';

// 各功能适配器
export { gameAdapter } from './game-adapter';
export { featuredAdapter } from './featured-adapter';
export { searchAdapter } from './search-adapter';
export { downloadAdapter } from './download-adapter';
export { iconAdapter } from './icon-adapter';
export { userAdapter } from './user-adapter';
export { settingsAdapter } from './settings-adapter';

// 统一的API客户端实例
import { createApiClient } from '../api/client';

/**
 * 全局API客户端实例
 * 在整个应用中使用同一个实例
 */
export const apiClient = createApiClient({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://back.002038.xyz',
});
